import { gql } from "@apollo/client";

export const REMOVE_HASHTAG = gql`
  mutation removeHashtag($id: Int!) {
    removeHashtag(id: $id) {
      id
    }
  }
`;
